import React from "react";
import { Image, Container, Row, Col } from "react-bootstrap";
import "./pscElections.style.scss";
import { Calendar } from "../../components";
import { starIconOrange, iconPlus, iconMinus, iconQuizLP01, power1, power2, power3 } from "../../lib/images";
import Collapse from "react-bootstrap/Collapse";
import { useState } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useMediaQuery } from "react-responsive";

function QuizLPpscElections() {
  const isMobile = useMediaQuery({ query: "(max-width: 768px)" });

  const { t } = useTranslation();
  const [open1, setOpen1] = useState(!isMobile);
  const [open2, setOpen2] = useState(!isMobile);
  const [open3, setOpen3] = useState(!isMobile);
  const [open4, setOpen4] = useState(!isMobile);

  const [sec1, setSec1] = useState(!isMobile);
  const [sec2, setSec2] = useState(false);
  const [sec3, setSec3] = useState(false);

  const toggleSec = (sec) => {
    setSec1(false);
    setSec2(false);
    setSec3(false);
    if (sec === "sec1") setSec1(true);
    if (sec === "sec2") setSec2(true);
    if (sec === "sec3") setSec3(true);
  };
  function goToAnchor(anchor) {
    var loc = document.location.toString().split("#")[0];
    document.location = loc + "#" + anchor;
    return false;
  }
  let desktopFAQs = (
    <div id="collapse-text-05" className="collapse-text-content">
      <div className="collape-item-leader">
        <Trans i18nKey="do_you_have_questions"></Trans>
      </div>
      <div className="collapse-text-item">
        <div className="col-left">
          <div className="text-content">
            <button
              type="button"
              className={sec1 ? "btn-action-what active" : "btn-action-what"}
              onClick={() => toggleSec("sec1")}
            >
              {t("what_public_service_commission_district")}
            </button>
            <button
              type="button"
              className={sec2 ? "btn-action-what active" : "btn-action-what"}
              onClick={() => toggleSec("sec2")}
            >
              {t("why_are_public_service_commission")}
            </button>
            <button
              type="button"
              className={sec3 ? "btn-action-what active" : "btn-action-what"}
              onClick={() => toggleSec("sec3")}
            >
              {t("what_local_elections")}
            </button>
          </div>
        </div>
        <div className="col-right">
          {sec1 ? (
            <div className="section-item">
              <div className="col-right-text">
                <div className="title">
                  {" "}
                  <span className="underline-emphasis">{t("both_districts_will_be")}</span>
                </div>
                <div className="content">{t("public_service_commission_seats_are_voted")}</div>
              </div>
            </div>
          ) : null}
          {sec2 ? (
            <div className="section-item">
              <div className="col-right-text">
                <div className="title">
                  <span className="underline-emphasis">
                    <Trans i18nKey="youre_right">
                      <i> </i>
                    </Trans>
                  </span>{" "}
                </div>
                <div className="content">
                  <p>
                    <Trans i18nKey="this_years_elections_are_unusual">
                      <a
                        href="https://www.savannahnow.com/story/news/state/2024/07/18/environmental-groups-file-lawsuit-over-psc-elections-in-georgia/74443853007/"
                        target="_blank"
                        rel="noreferrer noopener"
                      >
                        {" "}
                      </a>
                    </Trans>
                  </p>
                </div>
              </div>
            </div>
          ) : null}
          {sec3 ? (
            <div className="section-item">
              <div className="col-right-text">
                <div className="title">
                  <span className="underline-emphasis">{t("there_are_city_council")}</span>
                </div>
                {/* <div className="content">
                  <p>
                    <Trans i18nKey="to_find_out_whats_on_your_ballot">
                      <a
                        href="/ballot"
                        target="_self"
                        rel="noreferrer noopener"
                      >
                        {" "}
                      </a>
                    </Trans>
                  </p>
                </div> */}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
  let mobileFAQs = (
    <div id="collapse-text-05" className="collapse-text-content">
      <div className="collapse-item mobile-collapse">
        <div className="collape-item-leader">
          <Trans i18nKey="do_you_have_questions"></Trans>
        </div>
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("what_public_service_commission_district")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setSec1(!sec1)}
            aria-controls="collapse-faq-01"
            aria-expanded={sec1}
          >
            {sec1 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={sec1} className="col-right">
          <Container id="collapse-faq-01" className="section-item">
            <div>
              <div className="title">
                <span className="underline-emphasis">{t("both_districts_will_be")}</span>
              </div>
              <div className="content">
                <Trans i18nKey="public_service_commission_seats_are_voted">
                  <a href="tel:8889101368"> </a>
                </Trans>
              </div>
            </div>
          </Container>
        </Collapse>
      </div>
      <div className="collapse-item mobile-collapse">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("why_are_public_service_commission")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setSec2(!sec2)}
            aria-controls="collapse-faq-02"
            aria-expanded={sec2}
          >
            {sec2 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={sec2} className="col-right">
          <Container id="collapse-faq-02" className="section-item">
            <div className="title">
              <span className="underline-emphasis">
                {" "}
                <Trans i18nKey="youre_right">
                  <i> </i>
                </Trans>
              </span>
            </div>
            <div className="content">
              <p>
                <Trans i18nKey="this_years_elections_are_unusual">
                  <a
                    href="https://www.savannahnow.com/story/news/state/2024/07/18/environmental-groups-file-lawsuit-over-psc-elections-in-georgia/74443853007/"
                    target="_blank"
                    rel="noreferrer noopener"
                  >
                    {" "}
                  </a>
                </Trans>
              </p>
            </div>
          </Container>
        </Collapse>
      </div>
      <div className="collapse-item mobile-collapse">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("what_local_elections")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setSec3(!sec3)}
            aria-controls="collapse-faq-03"
            aria-expanded={sec3}
          >
            {sec3 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={sec3} className="col-right">
          <Container id="collapse-faq-03" className="section-item">
            <div className="title">
              <span className="underline-emphasis">{t("there_are_city_council")}</span>
            </div>
            {/* <div className="content">
              <p>
                <Trans i18nKey="to_find_out_whats_on_your_ballot">
                  <a href="/ballot" target="_self" rel="noreferrer noopener">
                    {" "}
                  </a>
                </Trans>
              </p>
            </div> */}
          </Container>
        </Collapse>
      </div>
    </div>
  );
  return (
    <div
      className="ctn-quiz-lp04 psc-elections voter-reg-page
    "
    >
      <div className="quiz-lp-top-header">
        <Image src={starIconOrange} className="icon-star-left" alt="" />
        <div className="top-header-title">
          <p>{t("on_the_ballot_this_year")}</p>
          <p>{t("voting_in_the_2025")}</p>
        </div>
        <Image src={starIconOrange} className="icon-star-right" alt="" />
      </div>
      <div className="quiz-lp-btn-action">
        <button
          type="button"
          className="btn-action-item"
          onClick={() => {
            setOpen1(true);
            goToAnchor("what");
            return false;
          }}
        >
          {t("what")}
        </button>
        <button
          type="button"
          className="btn-action-item"
          onClick={() => {
            setOpen2(true);
            goToAnchor("why");
            return false;
          }}
        >
          {t("why")}
        </button>
        <button
          type="button"
          className="btn-action-item"
          onClick={() => {
            setOpen3(true);
            goToAnchor("dates");
            return false;
          }}
        >
          {t("dates")}
        </button>
        <button
          type="button"
          className="btn-action-item"
          onClick={() => {
            setOpen4(true);
            goToAnchor("faq");
            return false;
          }}
        >
          {t("FAQ")}
        </button>
      </div>
      <div className="collape-item" id="what">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("the_2025_public")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setOpen1(!open1)}
            aria-controls="collapse-text-01"
            aria-expanded={open1}
          >
            {open1 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={open1}>
          <div id="collapse-text-01" className="collapse-text-content">
            <div className="collapse-text-item">
              <div className="col-left">
                <div className="text-content">{t("according_to_the_georgia_psc")}</div>
                <div className="text-content">{t("there_are_also_municipal")}</div>
              </div>
              <div className="col-right">
                <Image src={iconQuizLP01} />
              </div>
            </div>
          </div>
        </Collapse>
      </div>
      <div className="collape-item" id="why">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("why_these_elections_matter")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setOpen2(!open2)}
            aria-controls="collapse-text-02"
            aria-expanded={open2}
          >
            {open2 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={open2}>
          <Container id="collapse-text-02" className="collapse-text-content" fluid>
            <Row className="ctn-quiz-lp0102-rgtcontent">
              <Col xs="12" md="6" className="col-left">
                <div className="title">
                  <span className="underline-emphasis order-0">{t("your_wallet")}</span>
                </div>
                <p>{t("the_public_service_commission_psc_is")}</p>
                <div className="why-image">
                  <Image src={power1} />
                </div>
              </Col>
              <Col xs="12" md="6" className="col-right">
                <div className="title">
                  <span className="underline-emphasis order-0">{t("the_environment")}</span>
                </div>
                <p>{t("public_service_commissioners_get")}</p>
                <div className="why-image">
                  <Image src={power2} />
                </div>
              </Col>
              <Col xs="12" className="section-bottom">
                <Row className="why-bottom-row">
                  <Col xs="12" md="6" className="col-left">
                    <div className="title">
                      <span className="underline-emphasis order-0">{t("our_communities")}</span>
                    </div>
                    <p>
                      <Trans i18nKey="public_service_commissioners_have">
                        <a
                          href="https://capitalbnews.org/eminent-domain-railroad-sparta-ga-psc/"
                          target="_blank"
                          rel="noreferrer noopener"
                        >
                          {" "}
                        </a>
                      </Trans>
                    </p>
                  </Col>
                  <Col xs="12" md="6" className="col-right">
                    <div className="why-image">
                      <Image src={power3} />
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </Collapse>
      </div>
      <div className="collape-item thick-border-top" id="dates">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("save_these_important")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setOpen3(!open3)}
            aria-controls="collapse-text-03"
            aria-expanded={open3}
          >
            {open3 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={open3}>
          <Container id="collapse-text-03" className="collapse-text-content margin-padding-zero" fluid>
            <Calendar isPSC={true} />
          </Container>
        </Collapse>
      </div>
      <div className="collape-item" id="faq">
        <div className="collape-item-top">
          <div className="collape-item-lable">{t("FAQ")}</div>
          <button
            type="button"
            className="collape-item-button"
            onClick={() => setOpen4(!open4)}
            aria-controls="collapse-text-04"
            aria-expanded={open4}
          >
            {open4 ? <Image src={iconMinus} className="icon-minus" /> : <Image src={iconPlus} />}
          </button>
        </div>
        <Collapse in={open4}>{isMobile ? mobileFAQs : desktopFAQs}</Collapse>
      </div>
    </div>
  );
}
export default QuizLPpscElections;
